import type { ReactNode } from "react";

import { cx } from "./cx";
import { Skeleton } from "./skeleton";
import styles from "./stat-box.module.css";

export interface StatBoxProps {
  label: string;
  value: ReactNode;
  sub?: string;
  loading?: boolean;
  className?: string;
}

export function StatBox({
  label,
  value,
  sub,
  loading = false,
  className,
}: StatBoxProps) {
  return (
    <div className={cx(styles.box, className)}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>
        {loading ? <Skeleton className={styles.skeleton} /> : value}
      </span>
      {sub ? <span className={styles.sub}>{sub}</span> : null}
    </div>
  );
}
